const getRootCssVariable = (key: string): string => getComputedStyle(document.documentElement)
  .getPropertyValue(key)
  .trim();

export default getRootCssVariable;
